import { AfterContentInit, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApplicationContextService, CustomerDetailsService, ICustomerSummaryModel, RolePermissionService, UtilitiesService, ToShippingMethodTitle, FrameCommunicationService } from 'lib-core-shared';
import { PageBaseDirective } from '../directives/page-base.directive';

@Component({
  selector: 'app-customer-summary',
  templateUrl: './customer-summary.component.html',
  styleUrls: ['./customer-summary.component.scss'],
  providers: [ToShippingMethodTitle]
})
export class CustomerSummaryComponent extends PageBaseDirective<ICustomerSummaryModel> implements OnChanges, AfterContentInit {
  @Input() public summary!: ICustomerSummaryModel;
  pipe:any
  constructor(fb: FormBuilder,
    public customerDetailService: CustomerDetailsService,
    public roleService: RolePermissionService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public modalService: NgbModal,
    public utilitiesService: UtilitiesService,
    public applicationContext: ApplicationContextService,
    public toShippingMethodTitle: ToShippingMethodTitle,
    public frameCommunicationService: FrameCommunicationService) {
    super(activatedRoute, router, modalService, utilitiesService, roleService, applicationContext);
  }

  ngAfterContentInit(): void {
    if (this.broadCastSubmssion$) {
      this.broadCastSubmssion$.subscribe(x => {
        this.response$ = this.customerDetailService.get(this.summary.id);
        this.getDetail();
        this.response$?.subscribe((result) => {
          this.summary = result;
          this.isBusy = false;
        }, error => {
          this.frameCommunicationService.disableCustomerManagement();
        });
      });
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {}

  getShippingMethodTitle() {
    return this.toShippingMethodTitle.transform(this.summary.defaultShippingMethodId)
  }
}
